import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './QuickActionCard.css';

const QuickActionCard = ({ title, description, icon, color, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <Card
      className="quick-action-card"
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        borderRadius: '16px',
        border: '2px solid #e0e0e0',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 24px rgba(0, 34, 68, 0.15)',
          border: `2px solid ${color}`,
          '& .action-arrow': {
            transform: 'translateX(4px)',
            color: color
          }
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: '12px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {React.cloneElement(icon, {
              sx: { fontSize: 32, color: color }
            })}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                color: '#002244',
                fontWeight: 600,
                fontSize: '1rem',
                mb: 0.5
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666',
                fontSize: '0.85rem',
                lineHeight: 1.4
              }}
            >
              {description}
            </Typography>
          </Box>
          <ArrowForwardIcon
            className="action-arrow"
            sx={{
              color: '#ccc',
              transition: 'all 0.3s ease',
              fontSize: 24
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActionCard;
